import React from 'react';
import styled from 'styled-components';
import { screenXsMin, screenMdMin } from '@spotify-internal/encore-web';

import {
  COLOR_BLACK,
  COLOR_SPOTIFY_GREEN,
} from 'client/components/MarketingPagesShared/styles';
import { PODCAST_COLORS } from 'client/utils';
import { RetinaPicture } from 'client/components/RetinaPicture';
import { useT } from 'client/i18n/hooks/useT';

const MeetAnchorSection = styled.section`
  width: 100%;
  padding: 100px 24px 60px;
  background: ${COLOR_BLACK};

  @media (max-width: ${screenMdMin}) {
    padding: 80px 6%;
  }

  @media (max-width: ${screenXsMin}) {
    padding: 30px 6%;
  }
`;

const MeetAnchorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 985px;
  margin: 0 auto 40px;

  @media (max-width: ${screenMdMin}) {
    flex-direction: column-reverse;
    margin: 0 auto;

    picture {
      width: 100%;

      img {
        width: 100%;
      }
    }
  }
`;

const MeetAnchorContentContainer = styled.div`
  margin-left: 110px;

  @media (max-width: ${screenMdMin}) {
    margin-left: 0;
  }

  h2 {
    margin: 0 0 25px;
    color: ${COLOR_SPOTIFY_GREEN};
    font-size: 3.125rem;
    line-height: 55px;

    @media (max-width: ${screenXsMin}) {
      font-size: 2rem;
      line-height: 36px;
    }
  }

  p {
    margin: 0;
    color: ${PODCAST_COLORS.WHITE.color};
    font-size: 1.125rem;
    line-height: 26px;

    @media (max-width: ${screenMdMin}) {
      margin: 0 0 60px;
    }

    @media (max-width: ${screenXsMin}) {
      margin: 0 0 20px;
      font-size: 0.875rem;
      line-height: 26px;
    }
  }
`;

export function MeetAnchor() {
  const t = useT();

  // TODO https://anchorfm.atlassian.net/browse/CAST-2750: Final copy update and translate
  const title = t(
    'IntegrationConnectionScreen.MeetAnchor.Title',
    'Meet Anchor by Spotify',
    'The title for the Meet Anchor section on the Integration Connection Screen'
  );
  const body = t(
    'IntegrationConnectionScreen.MeetAnchor.Body',
    "Anchor is Spotify's free creation platform, powering more new podcasts than any other platform in the world. It's the destination for all things podcasting: Easily create, distribute, and monetize your show through Anchor—all for free. Once your show is uploaded, it's available to enjoy on Spotify.",
    'The body for the Meet Anchor section on the Integration Connection Screen'
  );
  return (
    <MeetAnchorSection>
      <MeetAnchorContainer>
        <RetinaPicture
          imagePath="/videopartner/videopartner-meetAnchor-group-of-podcasters"
          alt={t(
            'IntegrationConnectionScreen.MeetAnchor.MarketingImageAlt',
            'Group of female podcasters creating an episode at a park table',
            'Marketing image alt-text to discribe the image for screenreaders on the Integration Connection screen'
          )}
          fallbackExtension="jpg"
        />
        <MeetAnchorContentContainer>
          <h2>{title}</h2>
          <p>{body}</p>
        </MeetAnchorContentContainer>
      </MeetAnchorContainer>
    </MeetAnchorSection>
  );
}
